export default __webpack_public_path__ + "static/media/icn_cc_logo@2x.858adce1.png";